<app-modal-base [title]="title" (onSubmitEvent)="onSubmit()" [isDisabled]="form.invalid" [loading]="isLoading">
    <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
    <div mat-dialog-content>
        <form [formGroup]="form">
            <!--
            // FIXME: the start and delivery dates are not set for each buiding component but globally
            // Disable them for now
            <div class="form-group row">
                <app-input type="date" [label]="'Date de début'" [formControl]="form_startDate"></app-input>
                <app-input type="date" [label]="'Date de livraison'" [formControl]="form_deliveryDate"></app-input>
            </div>-->

            <div class="wrap-docs">
                @if (arePopulateData) {
                    @for (doc of f_documents?.controls; track $index) {
                        <app-doc-add-widget [withType]="false" [title]="(doc.value.documentType | buildingDocTypeTranslate) + ' (' + (doc.value.stage | bookletBuildingStageTranslate) +')'"
                                            [prop]="prop" [category]="'ENERGY'" [document]="doc.value?.docSummary"
                                            (docSelected)="onDocSelected($event, $index)" (docDeleted)="onDocDeleted($event, $index)"></app-doc-add-widget>
                    } @empty {
                        <p class="no-data">Aucun document n'est à renseigner</p>
                    }
                }
            </div>
        </form>
    </div>
  </ng-template>
